export const Users = [
  // {
  //   id: "498186030114013186",
  //   username: "Chadman",
  //   avatar:
  //     "https://cdn.discordapp.com/avatars/498186030114013186/cee62e3e37cfea6faeef6e9d4d9cd40c.webp?size=256"
  // },
  // {
  //   id: "208512715008770048",
  //   username: "Ryn",
  //   avatar:
  //     "https://cdn.discordapp.com/avatars/243905453858357250/a_7c425c8c4f2adbef096ddb522b923b85.webp?size=256"
  // },
  // {
  //   id: "208512715008770048",
  //   username: "JerryTerry",
  //   avatar:
  //     "https://cdn.discordapp.com/avatars/224753489857740800/5bd3e975180aa60f6acb4bce68af4b90.webp?size=256"
  // },
  // {
  //   id: "208512715008770048",
  //   username: "HalfShell",
  //   avatar:
  //     "https://cdn.discordapp.com/avatars/267455234740060170/6f1c8f9197454e7591066d5f55403942.webp?size=256"
  // },
  // {
  //   id: "208512715008770048",
  //   username: "Lio",
  //   avatar:
  //     "https://cdn.discordapp.com/avatars/272893214451695617/c456bbc1226f871b7167280a8b6c1c18.webp?size=256"
  // },
];

export const Messages = [
  // {
  //   user: {
  //     username: "HalfShell",
  //     avatar:
  //       "https://cdn.discordapp.com/avatars/267455234740060170/6f1c8f9197454e7591066d5f55403942.webp?size=256"
  //   },
  //   timestamp: new Date(),
  //   presentable: "Now that's a funny bunny!"
  // },
  // {
  //   user: {
  //     username: "Chadman",
  //     avatar:
  //       "https://cdn.discordapp.com/avatars/498186030114013186/cee62e3e37cfea6faeef6e9d4d9cd40c.webp?size=256"
  //   },
  //   timestamp: new Date(),
  //   presentable:
  //     "You know what, I hadn't thought about it like that. That's quite right."
  // },
  // {
  //   user: {
  //     username: "ScientistInsomniac",
  //     avatar:
  //       "https://cdn.discordapp.com/avatars/243905453858357250/a_7c425c8c4f2adbef096ddb522b923b85.webp?size=256"
  //   },
  //   timestamp: new Date(),
  //   presentable:
  //     "Now now let's not get ahead of ourselves, what if the bunny is actually devoid of humour?"
  // },
  // {
  //   user: {
  //     username: "Travall",
  //     avatar:
  //       "https://cdn.discordapp.com/avatars/262655459658432514/b017f09c244ebffbd4fc76cb7ee98358.webp?size=256"
  //   },
  //   timestamp: new Date(),
  //   presentable: "Just look at him, Ryn! Funniest thing I ever saw that bunny!"
  // },
  // {
  //   user: {
  //     username: "JerryTerry",
  //     avatar:
  //       "https://cdn.discordapp.com/avatars/224753489857740800/5bd3e975180aa60f6acb4bce68af4b90.webp?size=256"
  //   },
  //   timestamp: new Date(),
  //   presentable:
  //     "Well I've gotta say, I had my reservations, but now I'm sold. That's one funny bunny."
  // },
  // {
  //   user: {
  //     username: "Lio",
  //     avatar:
  //       "https://cdn.discordapp.com/avatars/272893214451695617/c456bbc1226f871b7167280a8b6c1c18.webp?size=256"
  //   },
  //   timestamp: new Date(),
  //   presentable:
  //     "I think he's the best bunny to have ever lived, and I'm a certified bunny expert."
  // },
  // {
  //   user: {
  //     username: "ScientistInsomniac",
  //     avatar:
  //       "https://cdn.discordapp.com/avatars/243905453858357250/a_7c425c8c4f2adbef096ddb522b923b85.webp?size=256"
  //   },
  //   timestamp: new Date(),
  //   presentable:
  //     "I think I'm with you guys now honestly, can't stop laughing at him!"
  // },
  // {
  //   user: {
  //     username: "Travall",
  //     avatar:
  //       "https://cdn.discordapp.com/avatars/262655459658432514/b017f09c244ebffbd4fc76cb7ee98358.webp?size=256"
  //   },
  //   timestamp: new Date(),
  //   presentable: "He really is hilarious!"
  // },
];
